import { c as _c } from "react/compiler-runtime";
import React from "react";
import { MdArrowDropDown } from "react-icons/md";
import { useTranslation } from "@/app/i18n/client";
import { cn } from "@/lib/utils";
import { GDPRCookiesSettingsPanelToggle } from "@/app/[lng]/_components/cookie-modal/cookie-settings-toggle";
import { Button } from "@/components/ui/button";
export function GDPRCookiesSettingsPanelSection(props) {
  const $ = _c(33);
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] !== props) {
    t0 = function handleToggle(value) {
      props.onToggle(props.id, String(value));
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleToggle = t0;
  let t1;
  if ($[2] !== props.title) {
    t1 = <div className="p-1 text-lg font-bold">{props.title}</div>;
    $[2] = props.title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = props.isDescripionExpanded && "max-h-24 min-h-4 p-1";
  let t3;
  if ($[4] !== t2) {
    t3 = cn("max-h-0 min-h-0 overflow-hidden transition-all", t2);
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props.description || $[7] !== t3) {
    t4 = <div className={t3}>{props.description}</div>;
    $[6] = props.description;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== props) {
    t5 = () => props.onToggleDescription(props.id);
    $[9] = props;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== props.isDescripionExpanded || $[12] !== t) {
    t6 = props.isDescripionExpanded ? t("GDPRSETTINGS.BUTTONS.SHOWLESS") : t("GDPRSETTINGS.BUTTONS.SHOWMORE");
    $[11] = props.isDescripionExpanded;
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = props.isDescripionExpanded && "rotate-180";
  let t8;
  if ($[14] !== t7) {
    t8 = cn("transition-transform", t7);
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <MdArrowDropDown className={t8} />;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t5 || $[19] !== t6 || $[20] !== t9) {
    t10 = <Button variant="inline-link" className="p-1 text-matchbus" onClick={t5}>{t6}{t9}</Button>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t1 || $[23] !== t10 || $[24] !== t4) {
    t11 = <div className="flex-1">{t1}{t4}{t10}</div>;
    $[22] = t1;
    $[23] = t10;
    $[24] = t4;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== handleToggle || $[27] !== props.allowChange || $[28] !== props.isAllowed) {
    t12 = <GDPRCookiesSettingsPanelToggle onToggle={handleToggle} allowChange={props.allowChange} isActive={props.isAllowed} />;
    $[26] = handleToggle;
    $[27] = props.allowChange;
    $[28] = props.isAllowed;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t11 || $[31] !== t12) {
    t13 = <div className="flex-1 flex-row">{t11}{t12}</div>;
    $[30] = t11;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  return t13;
}